<template>
 <div class="bankCards accountCreditCard ">
    <div class="wrap-card-w">
        <div class="wrap-card-box" v-for="(card,index) in cardList"
                     :key="index">
            <div class="card card-jianshe">
                <p class="card-name">
                    <i class="icon-banklogo"></i>{{card.other_branch_name}} 
                    {{card.other_acct_type|cardType}}
                </p>
                <p class="card-num">
                       {{card.other_acct_no}}
                    <span class="f-rt card-btn" @click="unbind(index)">解绑</span>
                </p>
            </div>
        </div>
    </div>
    <div class="list">
      <a class="item item-lg item-add" @click="bindCard">
          <i class="icon-w-add"></i>添加银行卡
      </a>
    </div>
    <p class="card-tips">最多绑定5张银行卡</p>
    <!-- <footer class="copyright">富力钱包由腾讯牵头发起设立的微众银行提供技术支持</footer> -->
 </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import {Get,Post} from '@/utils/http';
import { Toast } from 'mint-ui';
export default {
  name: 'BankCards',
  data () {
    return {
      wallet_id:'',
      cardList:[
            // {
            //     "binding_id": "123412",           //绑定ID
            //     "other_acct_no": "0987234949852345234",         //银行卡号(脱敏处理)
            //     "other_acct_type": 10,       //银行卡类型, 10: 借记卡, 20: 贷记卡; 30: 准贷记卡
            //     "other_branch_name": "中国银行",     //银行名称
            //     "other_branch_no": "12341234",       //银行联行号
            //     "daily_single_limit": "2000",    //单笔限额, 单位元
            //     "daily_limit": "2000",           //每日限额, 单位元
            //     "default_flag": "",          //默认卡标记, Y: 是; N: 否
            //     "open_super_flag": ""        //关联二类户, Y: 是; N: 否
            // },
            //  {
            //     "binding_id": "123412",           //绑定ID
            //     "other_acct_no": "0987234949852345234",         //银行卡号(脱敏处理)
            //     "other_acct_type": 10,       //银行卡类型, 10: 借记卡, 20: 贷记卡; 30: 准贷记卡
            //     "other_branch_name": "中国银行",     //银行名称
            //     "other_branch_no": "12341234",       //银行联行号
            //     "daily_single_limit": "2000",    //单笔限额, 单位元
            //     "daily_limit": "2000",           //每日限额, 单位元
            //     "default_flag": "",          //默认卡标记, Y: 是; N: 否
            //     "open_super_flag": ""        //关联二类户, Y: 是; N: 否
            // }
        ]
    }
},
 mounted() {
    Indicator.open();
    this.wallet_id = this.$route.params.wallet_id;
    this.getCardList();
  },
   methods: {
    getCardList() {
        const url = '/v1/person/wallet/card/list';
        const params = {
            wallet_id:this.wallet_id
        }
        Post(url,params).then((res)=>{
            this.cardList = res; 
            Indicator.close();
        }).catch((error)=>{
           Toast({
                message: "code:"+error.code+" message:"+error.msg,
                duration: 3000
            });
        })
    },
    bindCard(){
       const url = '/v1/person/wallet/card/bind';
       const params = {
            wallet_id:this.wallet_id,
            redirect:window.location.href
       }
       Indicator.open();
       Post(url,params).then((res)=>{
            Indicator.close();
            window.location = res.bank_card_bind_url;
       }).catch((error)=>{
            Toast({
                message: "code:"+error.code+" message:"+error.msg,
                duration: 3000
            });
       })
    },
    unbind (index) {
       const url = '/v1/person/wallet/card/unbind';
       const params = {
           wallet_id:this.wallet_id,
           binding_id:this.cardList[index].binding_id,
           redirect:window.location.href
       }
       Indicator.open();
       Post(url,params).then((res)=>{
            Indicator.close();
            window.location = res.bank_card_unbind_url;
       }).catch((error)=>{
            Indicator.close();
            Toast({
                message: error.msg,
                duration: 3000
            });
       })
    },
  },
 filters: {
    cardType(type){
      switch(type){
        case 10:   return '借记卡'; break;
        case 20:   return '贷记卡'; break;
        case 30:    return '准贷记卡';break;
        // default:  return s;
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.accountCreditCard{
  font-size: 16px;
  text-align: left;
}
.wrap-card-w {
   padding: .2rem .15rem .1rem;
}
.wrap-card-w .card {
    position: relative;
    width: 100%;
    height: 1rem;
    background: #fff;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -o-border-radius: 6px;
    border-radius: 6px;
    box-shadow: 0 2px 3px 1px rgba(0,0,0,.04);
    padding: .2rem;
    margin-bottom: .1rem;
}
.accountCreditCard .card {
    width: 3.2rem;
    margin: 0 auto .1rem;
}
.wrap-card-w .card .card-name {
    color: #66748a;
}
.banklogo-jianshe, .card.card-jianshe .icon-banklogo {
    background-position: 0 -400px;
    height: 50px;
    width: 50px;
}
.wrap-card-w .card .card-num {
    color: #97a4b8;
    font-size: 18px;
    margin-top: .1rem;
}
.wrap-card-w .card-btn {
    position: relative;
    display: inline-block;
    padding: 0 1.3em;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    color: #373c43;
    text-align: center;
    box-sizing: border-box;
}
.wrap-card-w .card-btn:after {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border: 1px solid #e7e7e7;
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    -o-border-radius: 12px;
    border-radius: 12px;
}
.f-rt {
    float: right;
}



.list {
    position: relative;
    background-color: #fff;
    overflow: hidden;
}
.board:before, .list:before, .otpLine .otp:before, .pop-content:before, .tab:before, .wrap-table:before {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border-top: 1px solid #f1f1f1;
    border-right: 0 solid #f1f1f1;
    border-bottom: 0 solid #f1f1f1;
    border-left: 0 solid #f1f1f1;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -o-border-radius: 0;
    border-radius: 0;
}
.item {
    padding-left: .15rem;
    padding-right: .15rem;
    position: relative;
    overflow: visible;
    display: block;
}
.item-lg {
    height: .6rem;
    line-height: .6rem;
}
.item-add {
    text-align: center;
    color: #3b8aff;
}
.icon-w-add, .icon-w-check {
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;
    width: 18px;
    display: inline-block;
}
.icon-w-add {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUxpcTuL/zuK/zyM/0WO/zuM/0CN/z2L/zyK/zyM/z6N/zyL/zyL/zyL/zyN/zyL/zyL/zuK/2aeZDgAAAARdFJOUwCto4kPTx5l9XUxw0CcJr/ZewhPUAAAAN5JREFUOMuVlO0WgyAIhtWwMC197/9m56o5c9ph/OAUPfElqNS/QnaLiTnFzdIAWTWjCOu1g8wmf/Iu7ER7cD6/mLllLIOnKgZN2WDvjAN08+OsAdcw7jeDu9UCtldKbZ+55+f0xZ8kDPSocxrm6s8Xf8uCpcqesV70pEaQms4oxKAxRGA6SvBqDCl/FLg1pTWQw5Z1RHiCAmLWCfsTtCNlXfJeTjEw19Mn8xpCKxVUwvU9neFEiYtaIGqm6FhEBywblWboblAZOtn4ihZBtlKy5ZStuezCkF09wktsLC+GURBymT14pAAAAABJRU5ErkJggg==);
    height: 18px;
}
.item-add .icon-w-add {
    vertical-align: middle;
    margin-top: -3px;
    margin-right: 5px;
}
.card-tips {
    text-align: center;
    padding: .05rem;
    font-size: 14px;
    color: #97a4b8;
}
</style>



// WEBPACK FOOTER //
// src/views/BankCards.vue